export default __webpack_public_path__ + "static/media/ext-link.40be0910.svg";